// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fffde0ca","455":"247441bc","686":"a9b8f485"}[chunkId] + ".chunk.js";
};